/**
 * Names are the contract with the gift email that links here; rename here only.
 */
export const GIFT_RECIPIENT_QUERY_PARAMS = {
	email: "recipientEmail",
	firstName: "recipientFirstName",
	lastName: "recipientLastName"
} as const;

export interface GiftRecipientParams {
	email?: string;
	firstName?: string;
	lastName?: string;
}

export function readGiftRecipientParams(
	searchParams: URLSearchParams
): GiftRecipientParams {
	const read = (key: string): string | undefined => {
		const value = searchParams.get(key)?.trim();
		return value ? value : undefined;
	};

	return {
		email: read(GIFT_RECIPIENT_QUERY_PARAMS.email),
		firstName: read(GIFT_RECIPIENT_QUERY_PARAMS.firstName),
		lastName: read(GIFT_RECIPIENT_QUERY_PARAMS.lastName)
	};
}
